import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, fmtPrice } from '../lib/api';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export default function ShoppingList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get('/shopping-list').then(r => setItems(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await api.delete(`/shopping-list/${id}`);
    setItems(items.filter(i => i.id !== id));
    toast.success('Eliminado');
  };

  const grouped = items.reduce((acc, it) => { (acc[it.room || 'Otros'] = acc[it.room || 'Otros'] || []).push(it); return acc; }, {});
  const total = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <main className="bg-stilo-bg" data-testid="shopping-list-page">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 pb-32">
        <p className="overline">Tu shopping list</p>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mt-3">
          <h1 className="md:col-span-8 font-serif text-6xl leading-[0.95]">Todo en un solo lugar.</h1>
          <div className="md:col-span-4 text-right">
            <p className="overline">Total estimado</p>
            <p className="font-serif text-4xl mt-2">{fmtPrice(total)}</p>
          </div>
        </div>

        {loading ? <p className="mt-16 text-stilo-ink2">Cargando…</p> : items.length === 0 ? (
          <div className="mt-16 border border-dashed border-stilo-ink/20 p-16 text-center">
            <p className="text-stilo-ink2">Aún no has guardado nada.</p>
            <Link to="/asesorias" className="btn-stilo mt-6 inline-flex">Reservar asesoría</Link>
          </div>
        ) : (
          <div className="mt-16 space-y-16">
            {Object.entries(grouped).map(([room, list]) => (
              <section key={room}>
                <p className="overline border-b border-stilo-ink/10 pb-3">{room} · {list.length} pieza{list.length>1?'s':''}</p>
                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
                  {list.map(it => (
                    <div key={it.id} className="group" data-testid={`sl-item-${it.id}`}>
                      <div className="relative bg-stilo-stone aspect-[4/5] overflow-hidden">
                        <img src={it.image} alt={it.title} className="w-full h-full object-cover" />
                        {it.added_by === 'designer' && <span className="absolute top-3 left-3 bg-stilo-olive text-stilo-bg overline px-2 py-1">Recomendado</span>}
                        <button onClick={() => remove(it.id)} className="absolute top-3 right-3 bg-stilo-bg/90 p-2 hover:bg-stilo-terra hover:text-stilo-bg transition-colors" data-testid={`remove-${it.id}`}>
                          <Trash2 className="w-4 h-4" strokeWidth={1.5} />
                        </button>
                      </div>
                      <p className="font-serif text-xl mt-3">{it.title}</p>
                      <p className="text-stilo-ink2 mt-1">{fmtPrice(it.price, it.currency)}</p>
                      {it.note && <p className="text-xs text-stilo-ink3 mt-2 italic">"{it.note}"</p>}
                    </div>
                  ))}
                </div>
              </section>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
